import { render, staticRenderFns } from "./prescription.vue?vue&type=template&id=b44b8e04&scoped=true"
import script from "./prescription.vue?vue&type=script&lang=js"
export * from "./prescription.vue?vue&type=script&lang=js"
import style0 from "./prescription.vue?vue&type=style&index=0&id=b44b8e04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44b8e04",
  null
  
)

export default component.exports